module.exports = __webpack_public_path__ + "static/media/lizel.dd3322cc.jpg";